import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { NoContactsFound } from 'components/templates/NoSearchResult'
import { executionsApi, ExecutionsUI } from 'features/executions'
import { hooks as ODataHooks } from 'shared/odata'
import { ContactsTable } from 'shared/ui'

import css from './CampaignContacts.module.scss'
import { Add } from './fallback-cards'

export function ExecutionsFlow() {
	const { isApplied, params } = ODataHooks.useParseUrl('Executions')

	const { data, isFetching, isLoading, isSuccess } =
		executionsApi.useExecutionsQuery(params, {
			refetchOnMountOrArgChange: true
		})

	ODataHooks.useCheckPagination({
		data,
		isApplied,
		isReady: isSuccess && !isFetching
	})

	// useAutomationEnded(() => {
	// 	refetch()
	// })

	if (isLoading) {
		return <FullLoader className={css.loader} />
	}

	if (!isSuccess) {
		return null
	}

	const { documents, total } = data

	const noData = total === 0

	if (noData && !isApplied) {
		return <Add />
	}

	return (
		<>
			<ExecutionsUI.Header />
			{isFetching && ContactsTable.Spinner}
			{noData ? (
				<NoContactsFound />
			) : (
				<ExecutionsUI.Table filter={params} items={documents} total={total} />
			)}
		</>
	)
}
